'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _components2 = require('components');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _info = require('redux/modules/info');

var _reactRouter = require('react-router');

var _docs = require('redux/modules/docs');

var _AgamaText = require('../../helpers/AgamaText');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Person: {
    displayName: 'Person'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/Song/Person.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Helmet from 'react-helmet';

// import { isSongsLoaded, loadSongs, isDocumentLoaded, loadDocument } from 'redux/modules/docs';


var Person = _wrapComponent('Person')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps, changeSongText: _docs.changeSongText, changeSongProp: _docs.changeSongProp, changeSongTextPersistent: _docs.changeSongTextPersistent, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Person, _Component);

  function Person() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Person);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Person.__proto__ || (0, _getPrototypeOf2.default)(Person)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      //showKitten: false
    }, _this.handleToggleKitten = function () {
      return _this.setState({ showKitten: !_this.state.showKitten });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Person, [{
    key: 'render',
    value: function render() {
      var styles = require('./Person.scss');
      var _props = this.props,
          songId = _props.songId,
          id = _props.id,
          docs = _props.docs,
          editMode = _props.editMode,
          changeSongProp = _props.changeSongProp,
          disabled = _props.disabled;
      var data = docs.data;
      var persons = data.docs.persons;

      var person = id === '_empty' ? '' : persons.filter(function (x) {
        return x.id === id;
      })[0];

      var changePerson = function changePerson(ev) {
        var personXid = ev.target.value;
        changeSongProp(songId /*xid*/, function (doc) {
          var interprets = doc.changes.interprets || doc.interprets;
          if (personXid === '_empty') {
            //mazeme
            var interprets3 = interprets.filter(function (x) {
              return x !== id;
            });
            if (interprets3.length === 0) delete doc.changes.interprets;else doc.changes.interprets = interprets3;
          } else {
            //nastavujemem nebo menime xid

            if (interprets.indexOf(personXid) > -1) {
              return; //uz je v kolekci
            }
            var interprets2 = [].concat((0, _toConsumableArray3.default)(interprets)); //klon                 
            if (id === '_empty') //pridavali jsme nový
              interprets2.push(personXid);else {
              var offset = interprets2.indexOf(id); //index sebe sama
              interprets2[offset] = personXid;
            }
            if ((0, _utils.areArraysEquals)(interprets2, doc.interprets)) delete doc.changes.interprets;else doc.changes.interprets = interprets2;
          }
        });
      };
      //const {showKitten} = this.state;

      if (!editMode) {
        return person.used ? _react3.default.createElement(
          'span',
          { itemProp: 'composer', itemScope: true, itemType: 'http://schema.org/MusicGroup' },
          _react3.default.createElement(
            _reactRouter.Link,
            { to: (0, _utils.frindlyName)('/' + id + '/' + person.name), className: styles.person },
            _react3.default.createElement(
              'span',
              { itemProp: 'name' },
              person.name
            )
          )
        ) : _react3.default.createElement(
          'span',
          { className: styles.person + ' ' + styles.unused },
          person.name
        );
      }

      var emptyPerson = [{ id: '_empty', name: '----' }];
      var options = emptyPerson.concat(persons).map(function (p) {
        //var selected = id == p.id;
        return _react3.default.createElement(
          'option',
          { value: p.id, key: 'ppp_' + p.id },
          p.name,
          ' '
        );
      });
      return _react3.default.createElement(
        'select',
        { className: styles.person, disabled: disabled, onChange: changePerson, value: id },
        options
      );
    }
  }]);
  return Person;
}(_react2.Component), _class2.propTypes = {
  docs: _react2.PropTypes.object,
  editMode: _react2.PropTypes.bool.isRequired,
  disabled: _react2.PropTypes.bool,
  id: _react2.PropTypes.string,
  songId: _react2.PropTypes.string,
  // versionId: PropTypes.string,
  // path: PropTypes.string.isRequired,
  // changeSongText: PropTypes.func.isRequired,
  changeSongProp: _react2.PropTypes.func.isRequired
  // changeSongTextPersistent: PropTypes.func.isRequired,
  // currentChord: PropTypes.string,
  // setUiProps: PropTypes.func.isRequired,
  // panelVisibleToSide: PropTypes.func.isRequired,
  // pushState: PropTypes.func.isRequired
}, _temp2)) || _class));

exports.default = Person;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Song/Person.js
// module id = 1192
// module chunks = 0